exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main_bg.dark-text{background:#fff;margin-bottom:2rem;margin-top:2rem}#filter_form2 .form-label{color:#000;display:block;font-size:15px;font-weight:700}#filter_form2 .slider-selection{background-color:#fa2837}#filter_form2 .slider-handle{background-color:#fa2837;background-image:none}", ""]);

// exports
